import React, {useImperativeHandle, useRef, useState,useEffect} from "react";
import {OrderedListOutlined} from "@ant-design/icons";
import {useModel} from "../../../models";
import {Col, Form, Input, Modal, Row, Select,InputNumber} from "antd";
import {decoder} from "../../../utils/decoder"
const TransferForm = ({formRef}) => {
    const [{accountList,selectedCustomer}, {transferAccount, setTransferModelVisible}] = useModel("customer");
    const [{payTypeDict,accountTypeDict}, {getPayTypeDict}] = useModel("cmDict");

    const initOptions = accountList.map(el => ({key: el.id, label: decoder(accountTypeDict,el.accountType), value: el.id}));
    const [sourceAccountOptions, setSourceAccountOptions] = useState(initOptions);
    const [targetAccountOptions, setTargetAccountOptions] = useState(initOptions);

    const [form] = Form.useForm();
    useEffect(()=>{
        form.setFieldsValue({...selectedCustomer});
    },[selectedCustomer])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        transfer: () => {
            console.log(form.getFieldsValue());
            form.validateFields().then(data => {
                transferAccount({data}).then(() => {
                    setTransferModelVisible(false);
                });
            })
        },
        reset: () => {
            form.resetFields();
        },
    }));
    const onSourceAccountChange = (value) => {
        const selectedSourceAccount = accountList.filter(el => el.id === value);
        if (selectedSourceAccount && selectedSourceAccount.length > 0) {
            form.setFieldsValue({transferOutId: selectedSourceAccount[0].id});
        }
        const filteredTargetOptions = initOptions.filter(el => !(el.key === value));
        setTargetAccountOptions(filteredTargetOptions)
    }
    const onTargetAccountChange = (value) => {
        const selectedTargetAccount = accountList.filter(el => el.id === value);
        console.log(selectedTargetAccount)
        if (selectedTargetAccount && selectedTargetAccount.length > 0) {
            form.setFieldsValue({transferToId: selectedTargetAccount[0].id});
        }
        setSourceAccountOptions(initOptions.filter(el => !(el.key === value)));
    }
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
            style={{marginRight: "50px"}}
        >
                 <Form.Item
                        name="customerName"
                        label="客户名称"
                    >
                        <Input disabled={true} placeholder="客户名称"/>
                    </Form.Item>            
                    <Form.Item
                        name="transferOutId"
                        label="转出账户"
                        rules={[{required: true, message: '转出账户是必输项',}]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择转出账户"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            onChange={onSourceAccountChange}
                            options={sourceAccountOptions}
                        />
                    </Form.Item>
                    <Form.Item
                        name="transferToId"
                        label="转入账户"
                        rules={[{required: true, message: '转入账户是必输项',}]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择转入账户"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            onChange={onTargetAccountChange}
                            options={targetAccountOptions}
                        />
                    </Form.Item>
                    <Form.Item
                        name="transferAmount"
                        label="转账金额"
                        rules={[{required: true, message: '转账金额是必输项',}]}
                    >
                        <InputNumber placeholder="转账金额"/>
                    </Form.Item>
                    <Form.Item
                        name="remarks"
                        label="备注"
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
        </Form>
    )
}

export default function () {
    const [{transferModelVisible, selectedAccount}, {setTransferModelVisible}] = useModel("customer")

    const formRef = useRef();

    const onOk = () => {
        formRef.current.transfer();
        // setTransferModelVisible(false);
    }
    const onClose = () => {
        setTransferModelVisible(false);
    }

    const Title = () => {
        return (
            <h3 style={{flex: "1"}}>
                <OrderedListOutlined/>
                <span className="margin-left-8">账户转账</span>
                {/* <span className="margin-left-16">{selectedAccount.supplierName}</span> */}
            </h3>
        )
    }
    return (
        <Modal
            title={<Title/>}
            width={500}
            visible={transferModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <TransferForm formRef={formRef}/>
        </Modal>
    );
}